import {
  downloadAllSelection,
  hiddenDownloadPool,
  type DownloadScope
} from '../../../property-assets-management/download-assets/downloadScope';
import { isPhotoAsset } from '../../../property-assets-management/model/isPhotoAsset';
import type { PhotosetWithAssets } from '../../../../types/asset.types';

/**
 * DV-2763: what the orders row's Download icon downloads — the order's own
 * photoset, the same photos and hidden pool the Manage Assets page's
 * Download All offers for that set (the rules are downloadScope's), sent as
 * explicit photoUUIDs.
 *
 * `photosetUUID` is the row's `resolvedPhotosetUUID` (DV-3366). `null` means
 * there is no photoset answer, and the caller keeps the order-tagged download
 * it has always made (with no include-hidden opt-in; see OrderCellAssets):
 * - the order resolves to no photoset;
 * - the set is not in the property's list: asset-service leaves out a set
 *   hidden from this customer, and order-service's stored link can name a
 *   set on ANOTHER property (DV-3428, ~2,300 prod orders, mostly duplicate
 *   property records in another account). That set is deliberately not
 *   fetched: the read would cross accounts;
 * - the set holds no photos.
 */
export const orderPhotosetDownload = (
  photosets: PhotosetWithAssets[],
  photosetUUID: string | null | undefined,
  seesHiddenStaged: boolean
): DownloadScope | null => {
  if (!photosetUUID) return null;
  const match = photosets.find(
    (entry) => entry.photoset.photosetId === photosetUUID
  );
  const photos = match?.assets.filter(isPhotoAsset) ?? [];
  if (photos.length === 0) return null;
  return {
    selection: downloadAllSelection(photos),
    hiddenPhotoUUIDs: hiddenDownloadPool(photos, seesHiddenStaged)
  };
};
